import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';
import baseQueryWith409 from './baseQueryWith409';

export const getCargos = query =>
	fetch.get(
		`/cargos${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getCargo = ({ id, query }) =>
	fetch.get(
		`/cargos/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addCargo = data => fetch.post('/cargos', data);
export const updateCargo = ({ id, ...data }) =>
	fetch.put(`/cargos/${id}`, data);
export const deleteCargo = id => fetch.delete(`/cargos/${id}`);

// RTK Query
export const cargosApi = createApi({
	reducerPath: 'cargosApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getCargos: build.query({
			query: query => {
				return {
					url: `/cargos${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({ type: 'Cargos', id })),
							{ type: 'Cargos', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'Cargos', id: 'LIST' }],
		}),
		getCargo: build.query({
			query: ({ id, query }) => {
				return {
					url: `/cargos/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'Cargos', id }],
		}),
		addCargo: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/cargos`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Cargo agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar cargo');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'Cargos', id: 'LIST' }],
		}),
		updateCargo: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/cargos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Cargo actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar cargo');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [{ type: 'Cargos', id }],
		}),
		deleteCargo: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/cargos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Cargo eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar cargo');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'Cargos', id }],
		}),
	}),
});

export const {
	useGetCargosQuery,
	useGetCargoQuery,
	useAddCargoMutation,
	useUpdateCargoMutation,
	useDeleteCargoMutation,
} = cargosApi;
